import { api } from "./api.js";
import { enrichSlot } from "../utils";

export const calendarService = {
  /**
   * Get calendar view for a date range
   * Returns already normalized data from backend
   * Format: { id, name, event_type, slot, participants, instructors }
   */
  getCalendarView: async (from, to) => {
    const response = await api.get("/calendar/view", {
      params: { from, to },
    });

    return (response.data || []).map((item) => ({
      ...item,
      slot: enrichSlot(item.slot),
    }));
  },
};
